import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1024 160V320Q1024 334 1015.0 343.0Q1006 352 992 352H896V864Q896 878 887.0 887.0Q878 896 864 896H544Q530 896 521.0 887.0Q512 878 512 864V704Q512 690 521.0 681.0Q530 672 544 672H640V352H544Q530 352 521.0 343.0Q512 334 512 320V160Q512 146 521.0 137.0Q530 128 544 128H992Q1006 128 1015.0 137.0Q1024 146 1024 160ZM896 1056V1216Q896 1230 887.0 1239.0Q878 1248 864 1248H672Q658 1248 649.0 1239.0Q640 1230 640 1216V1056Q640 1042 649.0 1033.0Q658 1024 672 1024H864Q878 1024 887.0 1033.0Q896 1042 896 1056ZM1433.0 1025.5Q1536 849 1536.0 640.0Q1536 431 1433.0 254.5Q1330 78 1153.5 -25.0Q977 -128 768.0 -128.0Q559 -128 382.5 -25.0Q206 78 103.0 254.5Q0 431 0.0 640.0Q0 849 103.0 1025.5Q206 1202 382.5 1305.0Q559 1408 768.0 1408.0Q977 1408 1153.5 1305.0Q1330 1202 1433.0 1025.5Z"
	})
});
export default SvgInfo;
